export default __webpack_public_path__ + "static/media/Db_5.1ce11887.png";